import React from 'react';
import {
  Container,
  Grid,
  Typography,
  Button,
  TextField,
  IconButton,
  Box,
  Divider,
} from '@mui/material';
import {
  Twitter as TwitterIcon,
  Facebook as FacebookIcon,
  YouTube as YouTubeIcon,
  LinkedIn as LinkedInIcon,
} from '@mui/icons-material';
import logopng from '../images/logopng.png';

const links = [
  { label: "About Us", href: "/about" },
  { label: "Contact Us", href: "/Contactwebsite" },
  { label: "Our Services", href: "/Webcourse" },
  // { label: "Terms & Conditions", href: "/terms" },
  { label: "Elearn", href: "/Elearn" },
];



const Footer = () => {
  return (
    <Box sx={{ bgcolor: '#2c3e50', color: '#ecf0f1', py: 4 }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Get In Touch Section */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h4" color="sccuess" fontWeight={540} gutterBottom>
              Get In Touch
            </Typography>
            <Box display="flex" alignItems="center" mb={2}>
              <img
                src={logopng}
                style={{ width: '30px', marginRight: '8px' }}
                alt="Allians International College"
              />
              <Typography variant="h6">Allians International College </Typography>
            </Box>
            <Typography variant="body2" paragraph>
              We provide learning opportunities for everyone to make a difference in them and society. Our programs are affordable for everyone.
            </Typography>
         </Grid>

          {/* Quick Links Section */}
          <Grid item xs={12} sm={6} md={4}>
            {/* <Typography variant="h6" color="sccuess">Quick Links</Typography>
            <Divider sx={{ mb: 2 }} />
            {links.map(link => (
  <Button
    key={link.label}
    href={link.href}
    color="inherit"
    sx={{
      justifyContent: 'flex-start',
      '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.1)' },
      mb: 1,
      textTransform: 'none', // Remove uppercase transformation
      fontWeight: '500', // Slightly bolder text
    }}
  >
    {link.label}
  </Button>
))} */}
      <Typography variant="body2"><strong>Address:</strong> Selegie Court , #04-153C, Selegie Road Singapore - 188 316</Typography>
            <Typography variant="body2"><strong>Phone:</strong> +65 8894 4752</Typography>
            <Typography variant="body2"><strong>Email:</strong> alliansinternationalcollege@gmail.com</Typography>
       
          </Grid>

          {/* Newsletter Section */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" color="sccuess">Newsletter</Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body2" sx={{ mb: 2 }}>
              Subscribe to our newsletter for the latest updates!
            </Typography>
            {/* <Box component="form" sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
              <TextField 
                variant="outlined" 
                placeholder="Your Email Address" 
                fullWidth 
                sx={{ mr: 1 }} 
                InputProps={{
                  sx: {
                     borderRadius: '20px', // Rounded corners
                    bgcolor: 'white', // White background for input
                  }
                }}
              />
              <Button variant="contained" color="primary" sx={{ borderRadius: '20px' }}>
                SignUp
              </Button>
            </Box> */}
            <Typography variant="h6" sx={{ mb: 1 }} color="sccuess">Follow Us</Typography>
            <Box display="flex" sx={{ gap: 1 }}>
              <IconButton color="inherit" href="#" target="_blank" aria-label="Twitter">
                <TwitterIcon />
              </IconButton>
              <IconButton
  color="inherit"
  // href="https://www.facebook.com/trentinternationalinstitute.sg"
  target="_blank"
  aria-label="Facebook"
>
  <FacebookIcon />
</IconButton>

              <IconButton color="inherit" href="#" target="_blank" aria-label="YouTube">
                <YouTubeIcon />
              </IconButton>
              <IconButton color="inherit" href="#" target="_blank" aria-label="LinkedIn">
                <LinkedInIcon />
              </IconButton>
            </Box>
          </Grid>
        </Grid>
      </Container>

      {/* Copyright Section */}
      <Box sx={{ bgcolor: '#34495e', py: 2, mt: 4 }}>
        <Container>
          <Typography variant="body2" align="center" sx={{ color: '#ecf0f1' }}>
            &copy; 2025 Allian International College. All rights reserved.
          </Typography>
          <Typography variant="body2" align="center" sx={{ color: '#ecf0f1', mt: 1 }}>
            Designed By © LIDER Technology Solution Pte Ltd.
          </Typography>
        </Container>
      </Box>
    </Box>
  );
};

export default Footer;
